export const ALREADY_READ_ERROR = 'Este pacote já foi lido. Item não contado.';

export const EXPIRED_BATCH_SEGREGATED =
	'O lote deste produto está fora do prazo de validade. Contado como segregado.';

export const NEAR_EXPIRATION_BATCH_SEGREGATED =
	'O lote deste produto está com o prazo de validade muito próximo do vencimento. Contado como segregado.';

export const REJECTED_BATCH_SEGREGATED =
	'O lote deste produto foi bloqueado pela equipe de qualidade. Contado como segregado.';
